/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {fetchClDetails} from "../../../api/clApi";
import { toast } from "react-toastify";




function useFetchCLDetails(id) {
    const [corrosionLoopData, setCorrosionLoopData] = useState(null);
    const [siteValue, setSiteValue] = useState(null);
    const [clLocationData, setCLLocationData] = useState(null);


    const fetchCorrosionLoop = () => {
        fetchClDetails(id).then((corrosionLoopData) => {
            setCorrosionLoopData(corrosionLoopData[0]);
            if (corrosionLoopData.length > 0) {
                setCLLocationData(corrosionLoopData[0]);
                setSiteValue(corrosionLoopData[0].siteName);
            }
        }).catch((error) => {
            console.error("Error fetching CML info:", error);
            toast.error("Cannot fetch CML info");
        }
        );
    };

    useEffect(() => {
        fetchCorrosionLoop();
    }, [id]);

    return { corrosionLoopData, siteValue, clLocationData }
}

export default useFetchCLDetails;